import { createContext } from 'react';

import { CurrentFcStore, GlobalState, TypeParamsNavigator } from './Global.interface';

export type GlobalContextProps = {
    globalState: GlobalState;
    setLoggedIn: (data: boolean) => void;
    setLoading: (data: boolean) => void;
    setCurrentFcStore: (data: CurrentFcStore) => void;
    setParamsNavigator: (data: TypeParamsNavigator) => void;
};

export const GlobalContext = createContext<GlobalContextProps>({} as GlobalContextProps);
